import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * An item with an optional `parent_id` reference to a parent item.
 * Can be a parent item itself.
 */

/**
 * A nestable item with a `children` property that contains
 * all of its children (or an empty array)
 */

/**
 * A nested readonly array of items
 */

/**
 * Converts a flat array into a nested array. 🌲
 *
 * All items must have an id field.
 *
 * Items with an undefined `parent_id` will be the top-level (root) nodes.
 * (If the root notes of the provided items have a different value, that value
 * can be specified via the second function parameter.)
 *
 * Nested items with a `parent_id` reference will be added to a `children`
 * array on the parent nodes.
 **/

export function arrayToTree(items) {
  var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return items.filter(function (item) {
    return item.parent_id === parentId;
  }).map(function (item) {
    var node = _objectSpread(_objectSpread({}, item), {}, {
      children: arrayToTree(items, item.id)
    });
    return node;
  });
}